module.exports = __webpack_public_path__ + "img/HomeTrack_Logo_RGB-cropped.7333871b.svg";